import axios from 'axios';

export default {
  authenticate: async (data) => {
    return axios.post(`${process.env.REACT_APP_USER_SERVICE_URL}/api/v1/users/authentication/student`, data);
  },
}
